import {EState} from '@app/state/reducers';
import {createFeatureSelector} from '@ngrx/store';
import {IMultiSelectState, ISelectState} from '../../models/dynamic-form.model';

export const selectMultiSelectState = createFeatureSelector<IMultiSelectState>(EState.MultiSelect);

export const selectSelectState = createFeatureSelector<ISelectState>(EState.Select);
